import { useSyncExternalStore } from "react";

// Reactive read of the active theme. The ThemeSwitch sets data-theme on
// <html>; a MutationObserver lets any component re-render when it flips, so
// screens can render their Sparkle variant without a context provider.

type Theme = "kovach-steele" | "sparkle";

function subscribe(onChange: () => void): () => void {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["data-theme"],
  });
  return () => observer.disconnect();
}

function getSnapshot(): Theme {
  return document.documentElement.getAttribute("data-theme") === "sparkle"
    ? "sparkle"
    : "kovach-steele";
}

export function useTheme(): Theme {
  return useSyncExternalStore(subscribe, getSnapshot, () => "kovach-steele");
}

export function useIsSparkle(): boolean {
  return useTheme() === "sparkle";
}
